export class Setting {
	customerIsin: string;
	lightTheme: boolean;
	applyCommissionInPortfolio: boolean;
	buyQuantity: number;
	dataTracker: boolean;
	divideOrderToMultiple: boolean;
	noBalance: boolean;
	noSleep: boolean;
	notchDown: boolean;
	notchUp: boolean;
	blinkOnDataChange: boolean;
	orderConfirmation: boolean;
	portfolioBasedOnLastPositivePeriod: boolean;
	priceFromHeadline: boolean;
	sellQuantity: number;
	showNotifications: boolean;
	tick: number;
	tickType: TickType;
	useClosingPriceInPortfolioTotalValue: boolean;
	usePersianNumber: boolean;
	userStatusBarToUp: boolean;
	portfolioTotalValueCalculateType: PortfolioTotalValueCalculateType;
	priceFromHeadlineSide: PriceFromHeadlineSide;
	portfolioBuyAveragePriceCalculationType: PortfolioBuyAveragePriceCalculationType;
	portfolioCalculationType: PortfolioCalculationType;
	soldPortfolioBuyAveragePriceCalculationType: PortfolioBuyAveragePriceCalculationType;
	soldPortfolioCalculationType: PortfolioCalculationType;
	keepOrderFormAfterSubmit: boolean;
}

export enum PortfolioTotalValueCalculateType {
	ClosePrice = 0,
	Automatic = 1,
	LastTradedPrice = 2
}

export enum PortfolioBuyAveragePriceCalculationType {
	WithDPS = 0,
	WithOutDPS = 1
}

export enum PortfolioCalculationType {
	Periodic = 0,
	Total = 1
}

export enum TickType {
	Amount = 'Amount',
	Percent = 'Percent'
}
export enum PriceFromHeadlineSide {
	Same,
	Opposite
}
export const defaultSettings: Setting = {
	customerIsin: null,
	lightTheme: true,
	buyQuantity: 10000,
	sellQuantity: 10000,
	tick: 0.5,
	tickType: TickType.Percent,
	priceFromHeadline: true,
	orderConfirmation: false,
	divideOrderToMultiple: false,
	notchUp: false,
	notchDown: false,
	applyCommissionInPortfolio: true,
	useClosingPriceInPortfolioTotalValue: true,
	showNotifications: true,
	noSleep: true,
	noBalance: false,
	blinkOnDataChange: true,
	userStatusBarToUp: false,
	portfolioBasedOnLastPositivePeriod: false,
	dataTracker: false,
	usePersianNumber: false,
	portfolioTotalValueCalculateType: PortfolioTotalValueCalculateType.LastTradedPrice,
	keepOrderFormAfterSubmit: false,
	priceFromHeadlineSide: PriceFromHeadlineSide.Same,
	portfolioBuyAveragePriceCalculationType: PortfolioBuyAveragePriceCalculationType.WithDPS,
	portfolioCalculationType: PortfolioCalculationType.Periodic,
	soldPortfolioBuyAveragePriceCalculationType: PortfolioBuyAveragePriceCalculationType.WithDPS,
	soldPortfolioCalculationType: PortfolioCalculationType.Periodic
};
